module.exports = __webpack_public_path__ + "static/media/iPhone2.ae0b7dcd.webp";